import styles from './styles.module.scss'
import { withModifiers } from '../../helpers/withModifiers'

const Spinner = ({ variant = [] }) => (
  <div className={withModifiers('spinner', variant, styles)}></div>
)

export default Spinner
